import { DOCUMENT } from '@angular/common';
import { Component, Input, AfterViewInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-matlist',
  templateUrl: './matList-section.component.html',
  styleUrls: ['./matList-section.component.scss'],
  standalone: false
})
export class MatListComponent implements AfterViewInit, OnDestroy {

  @Input() matlistContent: any;
  @Input() public header: string;
  @Input() public content: string;
  @Input() public item: string;
  @Input() public sectionFaq: string;

  @Input()
  public set expandAll(val: boolean) {
    this.showContent = val;
  }

  private _scrollTop = (e) => window.scrollTo(0,0);

  constructor(@Inject(DOCUMENT) private _document) { }

  showContent = false;

  ngAfterViewInit(): void {
      const anchorTags = this._document.getElementsByClassName('scroll-to-section');
      for(let i=0; i< anchorTags.length; i++) {
        const a = anchorTags.item(i);
        a.addEventListener('click', this._scrollTop)
      }
  }

  toggleContent() {
    this.showContent = !this.showContent;
  }

  ngOnDestroy(): void {
    const anchorTags = this._document.getElementsByClassName('scroll-to-section');
    for(let i=0; i< anchorTags.length; i++) {
      const a = anchorTags.item(i);
      a.removeEventListener('click', this._scrollTop);
    }
  }

}
